import { v4 as uuidv4 } from 'uuid';

export function MegaMenuGoBackBtn(props = {}, childrenComponents = []) {
	return {
		componentName: 'MegaMenuGoBackBtn',
		componentId: uuidv4(),
		props: Object.assign(
			{
				mzShow: false,
			},
			props,
		),
		childrenComponents,
	};
}
